import { useEffect, useRef } from 'react'
import { useUserInfo } from './useUserInfo'

/**
 * Custom hook for managing authentication flow and post-authentication navigation.
 *
 * Note: This hook only handles signIn events for navigation purposes.
 * Other auth events are handled by the global useAuthListener hook.
 */
export const useAuthFlow = () => {
  const { userId, isSignedIn } = useUserInfo()

  const wasSignedIn = useRef(false)

  useEffect(() => {
    // listen for changes to isSignedIn
    if (!wasSignedIn.current && isSignedIn) {
      const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
      const inParams = new URLSearchParams(window.location.search)
      const isCanvaUser = inParams.get('canva_user')
      const canvaUserId = inParams.get('userId')

      if (isCanvaUser === 'true' && userId) {
        // Handle Canva authentication flow
        handleCanvaAuthRedirect(
          API_GATEWAY_URL,
          inParams,
          canvaUserId,
          userId
        )
      }
    }

    // update wasSignedIn if isSignedIn changed
    if (wasSignedIn.current !== isSignedIn) {
      wasSignedIn.current = isSignedIn
    }
  }, [isSignedIn, userId])

  /**
   * Handle redirect for Canva authentication flow
   * @param {string} apiGatewayUrl - API Gateway base URL
   * @param {URLSearchParams} inParams - URL parameters from current page
   * @param {string} canvaUserId - Canva user ID
   * @param {string} kinstakUserId - Kinstak user ID
   */
  const handleCanvaAuthRedirect = (
    apiGatewayUrl,
    inParams,
    canvaUserId,
    kinstakUserId
  ) => {
    const params = new URLSearchParams({
      state: inParams.get('state'),
      canvaUserId: canvaUserId,
      userId: kinstakUserId
    })

    const redirectUrl = `${apiGatewayUrl}/k1/canva/success?${params.toString()}`
    window.location.replace(redirectUrl)
  }

  return {
    handleCanvaAuthRedirect
  }
}

export default useAuthFlow
